import React from 'react';
import { Container, Box, Grid, Typography, Link } from '@mui/material';

const FooterSection = ({ FadeInSection }) => {
    return (
        <Box sx={{ py: 4, bgcolor: 'grey.800' }}>
            <Container maxWidth="lg">
                <FadeInSection>
                    <Grid container spacing={4} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <Typography variant="body2" sx={{ color: 'grey.300' }}>
                                © 2024 - {new Date().getFullYear()} Find solution. Wszystkie prawa zastrzeżone.
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6} sx={{ textAlign: { xs: 'left', md: 'right' } }}>
                            <Link
                                href="/assets/Polityka prywatności.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    color: 'grey.300',
                                    mr: 2,
                                    textDecoration: 'none',
                                    '&:hover': { color: 'grey.100', textDecoration: 'underline' }
                                }}
                            >
                                Polityka Prywatności
                            </Link>
                            <Link
                                href="/assets/KLAUZULA INFORMACYJNA GS.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    color: 'grey.300',
                                    mr: 2,
                                    textDecoration: 'none',
                                    '&:hover': { color: 'grey.100', textDecoration: 'underline' }
                                }}
                            >
                                Klauzula Informacyjna
                            </Link>
                            <Link
                                href="/assets/Regulamin.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    color: 'grey.300',
                                    textDecoration: 'none',
                                    '&:hover': { color: 'grey.100', textDecoration: 'underline' }
                                }}
                            >
                                Regulamin
                            </Link>
                        </Grid>
                    </Grid>
                </FadeInSection>
            </Container>
        </Box>
    );
};

export default FooterSection;
